module.exports = __webpack_public_path__ + "static/media/jacksonville_team.5fb40647.jpg";